import { render, staticRenderFns } from "./ArticleSelect.vue?vue&type=template&id=053e0df4&scoped=true"
import script from "./ArticleSelect.vue?vue&type=script&lang=js"
export * from "./ArticleSelect.vue?vue&type=script&lang=js"
import style0 from "./ArticleSelect.vue?vue&type=style&index=0&id=053e0df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053e0df4",
  null
  
)

export default component.exports